import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M8.5 12.793V0h1v12.793l3.146-3.147.708.708L9 14.707l-4.354-4.353.708-.708L8.5 12.793zM18 16.5v1H0v-1h18z" fill="#fff" /></svg>;